import { VALUE_UPDATE_EVENT } from "../../lib/constants.js";
import { resolveTokenValue } from "../../lib/tokens.js";
import { Fragment, computed, createBlock, createElementBlock, createTextVNode, createVNode, openBlock, renderList, renderSlot, resolveDirective, toDisplayString, unref, withCtx, withDirectives } from "vue";
import { DtSegmentedControl, DtSegmentedControlItem, DtText } from "@dialpad/dialtone-vue";
//#region src/components/controls/control_segmented.vue
var _sfc_main = /* @__PURE__ */ Object.assign({ name: "DtcControlSegmented" }, {
	props: {
		value: {
			type: void 0,
			required: true
		},
		validValues: {
			type: Array,
			default: void 0
		},
		disabled: {
			type: Boolean,
			default: false
		},
		generateLabel: {
			type: Function,
			default: (value) => value.toString()
		},
		tokenCategory: {
			type: String,
			default: void 0
		},
		propValues: {
			type: Object,
			default: void 0
		}
	},
	emits: [VALUE_UPDATE_EVENT],
	setup(__props, { emit: __emit }) {
		const props = __props;
		const emit = __emit;
		const options = computed(() => {
			return props.validValues?.map((v) => ({
				value: v,
				label: props.generateLabel(v),
				resolved: props.tokenCategory ? resolveTokenValue(props.tokenCategory, v, props.propValues) : null
			})) ?? [];
		});
		const valueMap = computed(() => {
			const map = {};
			props.validValues?.forEach((v) => {
				map[String(v)] = v;
			});
			return map;
		});
		function onInput(stringValue) {
			emit(VALUE_UPDATE_EVENT, valueMap.value[stringValue]);
		}
		return (_ctx, _cache) => {
			const _directive_dt_tooltip = resolveDirective("dt-tooltip");
			return openBlock(), createElementBlock(Fragment, null, [createVNode(unref(DtText), {
				kind: "label",
				size: 100,
				tone: "secondary",
				class: "d-input__label-text d-c-default"
			}, {
				default: withCtx(() => [renderSlot(_ctx.$slots, "default")]),
				_: 3
			}), createVNode(unref(DtSegmentedControl), {
				"model-value": String(__props.value),
				size: 100,
				disabled: __props.disabled,
				onChange: onInput
			}, {
				default: withCtx(() => [(openBlock(true), createElementBlock(Fragment, null, renderList(options.value, (option) => {
					return withDirectives((openBlock(), createBlock(unref(DtSegmentedControlItem), {
						key: option.value,
						value: String(option.value)
					}, {
						default: withCtx(() => [createTextVNode(toDisplayString(option.label), 1)]),
						_: 2
					}, 1032, ["value"])), [[_directive_dt_tooltip, option.resolved ?? void 0]]);
				}), 128))]),
				_: 1
			}, 8, ["model-value", "disabled"])], 64);
		};
	}
});
//#endregion
export { _sfc_main as default };

//# sourceMappingURL=control_segmented.vue.js.map